import React from "react";
import "./style.css";
// import Typography from "antd/lib/typography";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDataEventInfo,
  fetchDataGifts,
  fetchDataSummary,
  fetchDataSummaryLasted,
  selectEventInfo,
  selectGifts,
  selectStoreCode,
  setStoreCode,
} from "../../redux/reducers/slice/event";
import PopupHighlight from "./PopupHighlight";
import { Helmet } from "react-helmet";
import { Form, Modal, Select } from "antd";
import { IEventStoreApplyModel } from "../../models/eventModel";
import ListSummary from "./ListSummary";
import BtnUseGuide from "./BtnUseGuide";
const INTERVAL_CALL_API = 5000;

const VoucherLucky = React.memo(() => {
  const dispatch = useDispatch();
  const evenInfo = useSelector(selectEventInfo);
  const storeCode = useSelector(selectStoreCode);
  const gifts = useSelector(selectGifts);
  const [visible, setVisible] = React.useState(true);
  const [windowSize, setWindowSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [form] = Form.useForm();

  const isTVDevice = windowSize.width >= 1920;
  const giftsBackground = isTVDevice
    ? "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/bg-tv-gift.png"
    : "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/bg-product-list.svg";

  React.useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  React.useEffect(() => {
    dispatch(fetchDataEventInfo());
  }, []);

  React.useEffect(() => {
    if (!evenInfo || !storeCode) {
      return;
    }

    dispatch(fetchDataSummary());
    dispatch(fetchDataSummaryLasted());
    dispatch(fetchDataGifts());

    const interval = setInterval(handleInterval, INTERVAL_CALL_API);
    return () => clearInterval(interval);
  }, [evenInfo, storeCode]);

  const handleInterval = () => {
    dispatch(fetchDataSummary());
    dispatch(fetchDataSummaryLasted());
    dispatch(fetchDataGifts());
  };

  const handleSubmit = (values: any) => {
    dispatch(setStoreCode(values.store_code));
    setVisible(false);
  };

  const showGiftItems = () =>
    gifts.map((item) => (
      <div className="lucky-wheel-gifts-item">
        <div className="lwgi-left">
          còn <b>{item.quantity - item.quantity_reward}</b> giải
        </div>
        <div className="lwgi-right">{item.display_name}</div>
      </div>
    ));

  const showStoreOptions = (stores: IEventStoreApplyModel[]) => {
    return stores.map((store) => (
      <Select.Option key={store.code} value={store.code}>
        {store.name}
      </Select.Option>
    ));
  };

  const render = () => {
    if (!evenInfo) {
      return <div className="screen-lucky-wheel-master">...loading</div>;
    }

    if (!gifts?.length) {
      return (
        <Modal
          visible={visible}
          cancelText="Đóng"
          title="Sự kiện & Khách hàng"
          cancelButtonProps={{ style: { display: "none" } }}
          closable={false}
          onOk={() => form.submit()}>
          <Form form={form} onFinish={handleSubmit}>
            <Form.Item
              label="Sự kiện"
              name="event_id"
              rules={[{ required: true, message: "Vui lòng chọn sự kiện" }]}
              labelCol={{ span: 5 }}
              labelAlign="right"
              initialValue={evenInfo._id}>
              <Select>
                <Select.Option key={evenInfo._id} value={evenInfo._id}>
                  {evenInfo.display_name}
                </Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Cửa hàng"
              name="store_code"
              rules={[{ required: true, message: "Vui lòng chọn cửa hàng" }]}
              labelCol={{ span: 5 }}
              labelAlign="right">
              <Select allowClear placeholder="Vui lòng chọn cửa hàng">
                {showStoreOptions(evenInfo.store_applies)}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      );
    }

    return (
      <div className="lucky-wheel-summary">
        <div className="lucky-wheel-items">
          <div className="lucky-wheel-gifts">
            <div className="logo-wrapper">
              <img src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/logo-tivi.png" />
            </div>
            <div className="gifts-wrapper">
              <img src={giftsBackground} alt="" className="bg-table-gifts" />
              <div className="lucky-wheel-gifts-title">Giải thưởng</div>
              <div className="lucky-wheel-gifts-listing">{showGiftItems()}</div>
              {!isTVDevice && (
                <div className="lucky-wheel-gift-dot">
                  <img
                    src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/ic-ball.svg"
                    alt=""
                  />
                </div>
              )}
            </div>
          </div>
          <div className="lucky-wheel-summary-container">
            {isTVDevice && (
              <div className="lucky-wheel-button">
                <span>Danh sách khách hàng trúng thưởng</span>
              </div>
            )}
            <ListSummary isTVDevice={isTVDevice} />
            {!isTVDevice && (
              <div className="lucky-wheel-button">
                <span>Danh sách khách hàng trúng thưởng</span>
              </div>
            )}
            <BtnUseGuide url={evenInfo?.store_applies?.find(x => x.code == storeCode)?.url_guide} />
            {/* <div className="lucky-wheel-button qr-button">
              <span>Thể lệ chương trình</span>
            </div> */}
          </div>
          {/* <div className="customer-rewards">
            <img
              src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/bg-summary.svg"
              alt=""
            />
            <div className="customer-rewards-header">
              <div>STT</div>
              <div>Khách hàng</div>
              <div>Mã đơn hàng</div>
              <div>Trúng thưởng</div>
            </div>
            {showRows()}
            {showItems()}
          </div> */}
        </div>
      </div>
    );
  };

  return (
    <div className="screen-lucky-wheel-master">
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <PopupHighlight isTVDevice={isTVDevice} />
      {render()}
      <img src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/bg-tv-popup-win.png" style={{ display: "none" }} />
      <img src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/bg-popup-win.svg" style={{ display: "none" }} />
    </div>
  );
});

export default VoucherLucky;
